





import Vue from 'vue'
import _ from 'lodash'
import { SET_DRAWER_STATE } from '@/store/mutation-types'
import AppMenu from '@/components/AppMenu.vue'

interface ComponentData {
  show: boolean | undefined
}

export default Vue.extend({
  name: 'AppDrawer',

  components: {
    AppMenu
  },

  computed: {
    showDrawer (): boolean {
      return this.$store.state.showDrawer
    }
  },

  watch: {
    showDrawer (newVal) {
      this.show = newVal
    },

    show (newValue: boolean): void {
      if (_.isBoolean(newValue)) {
        this.$store.commit(SET_DRAWER_STATE, newValue)
      }
    }
  },

  data (): ComponentData {
    return {
      show: undefined
    }
  }
})
